import { useQuery } from '@tanstack/react-query'
import { ClipboardCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useParams, useSearchParams } from 'react-router'
import { Button } from '@/components/ui/Button'
import { PageHeader } from '@/components/ui/PageHeader'
import { sectionMonthQuery } from '@/features/attendance/api'
import { SectionMonthHeatmap } from '@/features/attendance/components/SectionMonthHeatmap'
import { todayIso } from '@/features/attendance/dates'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export function SectionHistoryPage() {
  const { t } = useTranslation('attendance')
  const { id } = useParams()
  const sectionId = Number(id)
  const [params, setParams] = useSearchParams()
  const raw = params.get('month')
  const month = raw && /^\d{4}-(0[1-9]|1[0-2])$/.test(raw) ? raw : todayIso().slice(0, 7)
  // Shares the heatmap's cache entry, used here only for the title.
  const title = useQuery(sectionMonthQuery(sectionId, month)).data?.section.name
  useDocumentTitle(title ? t('{{section}} attendance', { section: title }) : 'Section attendance')

  return (
    <>
      <PageHeader
        title={title ?? t('Section attendance')}
        description={t('Daily present rate across the month. Select a day to open its register.')}
        breadcrumbs={[
          { label: t('Attendance'), to: '/admin/attendance' },
          { label: t('Daily register'), to: `/admin/attendance?section=${sectionId}` },
          { label: t('Monthly view') },
        ]}
        homeHref="/admin"
        actions={
          <Button asChild variant="secondary" leftIcon={<ClipboardCheck />}>
            <Link to={`/admin/attendance?section=${sectionId}`}>{t("Today's register")}</Link>
          </Button>
        }
      />
      <SectionMonthHeatmap
        sectionId={sectionId}
        month={month}
        onMonthChange={(m) => setParams({ month: m }, { replace: true })}
        dayHref={(date) => `/admin/attendance?section=${sectionId}&date=${date}`}
      />
    </>
  )
}
